import { useState } from "react";

interface IDropdonwProps {
  label: string;
  options: string[];
  onChange: (value: string) => void;
}

export const Dropdown = (props: IDropdonwProps) => {
  const [selected, setSelected] = useState("");

  const handleChange = (value: string) => {
    setSelected(value);
    props.onChange(value);
  };

  return (
    <div className="w-full">
      <label className="block text-sm font-medium text-[#b0e0e6] mb-1">
        {props.label}
      </label>
      <select
        className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-[#1a1a3e]"
        value={selected}
        onChange={(e) => handleChange(e.target.value)}
      >
        <option value="">Select a file</option>
        {props.options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
};
